import styled from 'styled-components';

export const PolicyLink = styled.a`
  padding-top: 10px;
  font-size: 14px;
  line-height: 19px;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.lightGray};
`;
